<div class="management-page">
    <app-breadcrumbs [model]="libraryBreadcrumbs()" />
    <header class="overview-header">
        <div>
            <p class="overview-eyebrow">{{ t()('management.eyebrow') }}</p>
            <h1>{{ t()('management.packages') }}</h1>
            <p class="overview-description">{{ t()('management.packagesDescription') }}</p>
        </div>
        <div class="overview-actions">
            <a pButton [outlined]="true" routerLink="/firmware">
                <i pButtonIcon class="pi pi-microchip" aria-hidden="true"></i>
                <span pButtonLabel>{{ t()('management.firmware') }}</span>
            </a>
            <p-button icon="pi pi-refresh" [outlined]="true" [ariaLabel]="t()('management.refresh')" [pTooltip]="t()('management.refresh')" [disabled]="libraryLoading()" (onClick)="loadPackages()" />
            @if (canManageAnyNamespace()) {
                <p-button [label]="t()('management.uploadPackage')" icon="pi pi-upload" (onClick)="openUploadDialog()" />
            }
        </div>
    </header>
    @if (selectedPackageId()) {
        <div class="management-detail-toolbar">
            <p-button [label]="t()('management.backToPackages')" icon="pi pi-arrow-left" [text]="true" (onClick)="closePackageDialog()" />
        </div>
    }
    <div class="detail-pane">
        @if (loadingLocationPackages()) {
            <div class="loading">
                <p-progressspinner></p-progressspinner>
                <span>Resolving packages at {{ preSelectLocationName() || 'location' }}...</span>
            </div>
        } @else if (!selectedPackageId()) {
            <div class="management-summary">
                <div class="management-stat"><span><i class="pi pi-box" aria-hidden="true"></i>{{ t()('management.availablePackages') }}</span><strong>{{ libraryLoading() || libraryError() ? '—' : tenantPackages().length }}</strong></div>
                <div class="management-stat"><span><i class="pi pi-building" aria-hidden="true"></i>{{ t()('management.tenant') }}</span><strong>{{ libraryTenantName() }}</strong></div>
                <div class="management-stat"><span><i class="pi pi-clock" aria-hidden="true"></i>{{ t()('management.lastUpdated') }}</span><strong>{{ !libraryLoading() && !libraryError() && latestPackageUpdate() ? formatDate(latestPackageUpdate()!) : '—' }}</strong></div>
            </div>
            <section class="management-panel" [attr.aria-label]="t()('management.packages')">
                <div class="management-toolbar">
                    <label class="management-search">
                        <i class="pi pi-search" aria-hidden="true"></i>
                        <input pInputText type="search" [attr.aria-label]="t()('management.searchPackages')" [placeholder]="t()('management.searchPackages')" [ngModel]="treeFilter()" (ngModelChange)="treeFilter.set($event || '')" />
                    </label>
                    @if (treeFilter()) { <p-button [label]="t()('management.clearFilters')" icon="pi pi-filter-slash" [text]="true" (onClick)="treeFilter.set('')" /> }
                    <span class="management-results">{{ libraryLoading() || libraryError() ? '—' : libraryPackages().length }} / {{ libraryLoading() || libraryError() ? '—' : tenantPackages().length }} {{ t()('management.shown') }}</span>
                </div>
                @if (libraryLoading()) {
                    <div class="management-state"><app-loading-skeleton preset="table" [count]="5" [label]="t()('management.loadingPackages')" /></div>
                } @else if (libraryError()) {
                    <div class="management-state"><app-empty-state icon="pi pi-exclamation-circle" tone="error" [title]="t()('management.packagesError')" [description]="t()('management.retryHint')" /></div>
                } @else if (libraryPackages().length === 0) {
                    <div class="management-state"><app-empty-state icon="pi pi-box" [title]="t()(treeFilter() ? 'management.noMatches' : 'management.noPackages')" [description]="t()(treeFilter() ? 'management.clearHint' : 'management.emptyPackagesHint')" /></div>
                } @else {
                    <p-table class="management-table" [value]="libraryPackages()" [paginator]="true" [rows]="15" [rowsPerPageOptions]="[15, 25, 50]" [first]="libraryFirst()" (onPage)="libraryFirst.set($event.first)" [rowHover]="true" [scrollable]="true" sortField="name" [sortOrder]="1">
                        <ng-template #header>
                            <tr>
                                <th pSortableColumn="name">{{ t()('management.name') }} <p-sorticon field="name" /></th>
                                <th pSortableColumn="programNamespace">{{ t()('management.programNamespace') }} <p-sorticon field="programNamespace" /></th>
                                <th pSortableColumn="updatedUtc">{{ t()('management.lastUpdated') }} <p-sorticon field="updatedUtc" /></th>
                                <th>{{ t()('management.createdBy') }}</th>
                                <th class="text-right">{{ t()('management.actions') }}</th>
                            </tr>
                        </ng-template>
                        <ng-template #body let-pkg>
                            <tr class="management-row-link" tabindex="0" role="link" [attr.aria-label]="t()('management.viewDetails') + ' ' + pkg.name" (click)="viewPackage(pkg)" (keydown.enter)="viewPackage(pkg)">
                                <td><div class="management-name"><i class="pi pi-box" aria-hidden="true"></i><div><button type="button" tabindex="-1" (click)="$event.stopPropagation(); viewPackage(pkg)">{{ pkg.name }}</button><small>{{ pkg.description }}</small></div></div></td>
                                <td><code>{{ pkg.programNamespace }}</code></td>
                                <td>{{ formatDate(pkg.updatedUtc) }}</td>
                                <td>{{ pkg.createdBy }}</td>
                                <td (click)="$event.stopPropagation()"><div class="management-row-actions">
                                    @if (canManagePackage(pkg)) {
                                        <p-button icon="pi pi-cloud-upload" [text]="true" [rounded]="true" [ariaLabel]="t()('management.deployLatest') + ' ' + pkg.name" [pTooltip]="t()('management.deployLatest')" tooltipPosition="left" (onClick)="openDeployForPackageId(pkg.id)" />
                                    }
                                    <p-button icon="pi pi-arrow-right" [text]="true" [rounded]="true" [ariaLabel]="t()('management.viewDetails') + ' ' + pkg.name" [pTooltip]="t()('management.viewDetails')" tooltipPosition="left" (onClick)="viewPackage(pkg)" />
                                </div></td>
                            </tr>
                        </ng-template>
                    </p-table>
                }
            </section>
        } @else if (loadingPackage()) {
            <div class="loading">
                <p-progressspinner></p-progressspinner>
            </div>
        } @else if (selectedPackage()) {
            <div class="package-details management-panel">
                <div class="package-header">
                    <div class="info">
                        <h3>{{ selectedPackage()?.package?.name }}</h3>
                        <code class="namespace">{{ selectedPackage()?.package?.programNamespace }}</code>
                        <p class="description">{{ selectedPackage()?.package?.description || 'No description' }}</p>
                    </div>
                    @if (canManagePackage(selectedPackage()!.package)) {
                        <div class="actions">
                            <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" (onClick)="openEditDialog(selectedPackage()!.package)" pTooltip="Edit"></p-button>
                            <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger" (onClick)="deletePackage(selectedPackage()!.package)" pTooltip="Delete"></p-button>
                        </div>
                    }
                </div>

                <p-tabs [value]="activeDetailTab()" (valueChange)="onDetailTabChange($event)">
                    <p-tablist>
                        <p-tab value="releases">Releases</p-tab>
                        @if (selectedPackage()!.package.gitHubRepository || canManagePackage(selectedPackage()!.package)) {
                            <p-tab value="issues">Issues</p-tab>
                        }
                        @if (canManagePackage(selectedPackage()!.package)) {
                            <p-tab value="links">Share Links</p-tab>
                        }
                    </p-tablist>
                    <p-tabpanels>
                        <p-tabpanel value="releases">
                @if (selectedPackage()?.latestVersion) {
                    <div class="latest-version">
                        <div class="latest-version-header">
                            <h4>Latest Version</h4>
                            @if (canManagePackage(selectedPackage()!.package)) {
                                <p-button label="Deploy Latest" icon="pi pi-cloud-upload" (onClick)="deployLatestVersion()"></p-button>
                            }
                        </div>
                        <div class="version-info">
                            <p-tag value="{{ selectedPackage()!.latestVersion!.assemblyVersion }}" severity="success"></p-tag>
                            @if (selectedPackage()!.latestVersion!.isDebugBuild) {
                                <p-tag value="Debug" severity="warn" [rounded]="true"></p-tag>
                            } @else {
                                <p-tag value="Release" severity="info" [rounded]="true"></p-tag>
                            } 
                            @if (selectedPackage()!.latestVersion!.buildTimeUtc) {
                                <span class="build-date">Built: {{ formatDate(selectedPackage()!.latestVersion!.buildTimeUtc) }}</span>
                            }
                            <span class="date">Uploaded: {{ formatDate(selectedPackage()!.latestVersion!.uploadedUtc) }}</span>
                            <span class="uploader">By: {{ selectedPackage()!.latestVersion!.uploadedBy }}</span>
                        </div>
                        @if (selectedPackage()!.latestVersion!.releaseNotes) {
                            <p-accordion class="release-notes-accordion">
                                <p-accordion-panel value="0">
                                    <p-accordion-header>Release Notes</p-accordion-header>
                                    <p-accordion-content>
                                        <div class="release-notes-content" [innerHTML]="selectedPackage()!.latestVersion!.releaseNotes | markdown"></div>
                                    </p-accordion-content>
                                </p-accordion-panel>
                            </p-accordion>
                        }
                    </div>
                }

                <div class="versions-header">
                    <h4>All Versions</h4>
                    @if (canDeleteVersions(selectedPackage()!.package)) {
                        <div class="versions-actions">
                            <p-button label="Clean Up" icon="pi pi-filter-slash" [text]="true" (onClick)="openCleanupDialog()" />
                            @if (selectedVersionsCount() > 0) {
                                <p-button label="Delete {{ selectedVersionsCount() }} Selected" icon="pi pi-trash" severity="danger" [text]="true" (onClick)="deleteSelectedVersions()" [loading]="deletingVersions()"> </p-button>
                            }
                        </div>
                    }
                </div>
                <div class="version-filters">
                    <input type="text" pInputText placeholder="Filter versions..." [ngModel]="versionFilter()" (ngModelChange)="setVersionFilter($event || '')" />
                    <p-select
                        [options]="[{ label: 'All builds', value: 'all' }, { label: 'Release only', value: 'release' }, { label: 'Debug only', value: 'debug' }]"
                        optionLabel="label"
                        optionValue="value"
                        [ngModel]="versionBuildFilter()"
                        (ngModelChange)="setVersionBuildFilter($event || 'all')"
                        [style]="{ width: '180px' }"
                        appendTo="body"
                    >
                    </p-select>
                </div>
                <p-table
                    [value]="displayedVersions()"
                    class="management-table versions-table"
                    dataKey="id"
                    [scrollable]="true"
                    [lazy]="true"
                    [loading]="loadingVersions()"
                    [totalRecords]="versionsTotal()"
                    [first]="versionsFirst()"
                    (onLazyLoad)="onVersionsLazyLoad($event)"
                    [paginator]="true"
                    [rows]="versionsPageSize()"
                    [rowsPerPageOptions]="[5, 10, 20, 50, 100]"
                    [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} versions"
                >
                    <ng-template #header>
                        <tr>
                            @if (canDeleteVersions(selectedPackage()!.package)) {
                                <th style="width: 50px">
                                    <p-checkbox [binary]="true" [ngModel]="allVersionsSelected()" (ngModelChange)="toggleAllVersions()" [indeterminate]="someVersionsSelected()"> </p-checkbox>
                                </th>
                            }
                            <th style="min-width: 250px">Version</th>
                            <th style="min-width: 100px">File Version</th>
                            <th style="min-width: 140px">Built</th>
                            <th style="min-width: 140px">Uploaded</th>
                            <th style="min-width: 100px">By</th>
                            <th style="min-width: 80px">Size</th>
                        </tr>
                    </ng-template>
                    <ng-template #body let-version>
                        <tr class="version-row" (click)="onVersionClick($event, version, versionMenu)">
                            @if (canDeleteVersions(selectedPackage()!.package)) {
                                <td (click)="$event.stopPropagation()">
                                    <p-checkbox [binary]="true" [ngModel]="version.selected" (ngModelChange)="toggleVersionSelection(version)" [disabled]="!!version.usage?.inUse" [pTooltip]="version.usage?.inUse ? 'In use — cannot be deleted' : ''" [ariaLabel]="'Select ' + version.assemblyVersion"> </p-checkbox>
                                </td>
                            }
                            <td>
                                <div class="version-badges">
                                    {{ version.assemblyVersion }} 
                                    @if (version.isLatest) {
                                        <p-tag value="Latest" severity="success" [rounded]="true"></p-tag>
                                    } 
                                    @if (version.isDebugBuild) {
                                        <p-tag value="Debug" severity="warn" [rounded]="true" pTooltip="Debug build"></p-tag>
                                    } @else {
                                        <p-tag value="Release" severity="info" [rounded]="true" pTooltip="Release build"></p-tag>
                                    } 
                                    @if (version.uploadSource === 'github-actions') {
                                        <i class="pi pi-github github-icon" pTooltip="Uploaded via GitHub Actions"></i>
                                    }
                                    @if (version.usage?.runningOnCount) {
                                        <p-tag class="usage-tag" severity="contrast" [rounded]="true" icon="pi pi-server" [value]="'On ' + version.usage!.runningOnCount + (version.usage!.runningOnCount === 1 ? ' device' : ' devices')" [pTooltip]="describeUsage(version.usage)"></p-tag>
                                    }
                                    @if (version.usage?.pendingDeploymentCount) {
                                        <p-tag class="usage-tag" severity="secondary" [rounded]="true" icon="pi pi-clock" value="Deploy pending" [pTooltip]="describeUsage(version.usage)"></p-tag>
                                    }
                                </div>
                            </td>
                            <td>{{ version.fileVersion ? version.fileVersion : '-' }}</td>
                            <td>{{ version.buildTimeUtc ? formatDate(version.buildTimeUtc) : '-' }}</td>
                            <td>{{ formatDate(version.uploadedUtc) }}</td>
                            <td>{{ version.uploadedBy }}</td>
                            <td>{{ formatFileSize(version.fileSizeBytes) }}</td>
                        </tr>
                    </ng-template>
                    <ng-template #emptymessage>
                        <tr>
                            <td [attr.colspan]="canDeleteVersions(selectedPackage()!.package) ? 7 : 6" class="text-center">{{ versionFilter() || versionBuildFilter() !== 'all' ? 'No versions match these filters' : 'No versions available' }}</td>
                        </tr>
                    </ng-template>
                </p-table>
                <p-contextmenu #versionMenu [model]="versionMenuItems()" [appendTo]="'body'"></p-contextmenu>
                        </p-tabpanel>
                        @if (selectedPackage()!.package.gitHubRepository || canManagePackage(selectedPackage()!.package)) {
                            <p-tabpanel value="issues">
                                <app-package-issues [pkg]="selectedPackage()!.package" [canConfigureTenant]="canConfigureTenant(selectedPackage()!.package)" />
                            </p-tabpanel>
                        }
                        @if (canManagePackage(selectedPackage()!.package)) {
                            <p-tabpanel value="links">
                                <app-package-links [pkg]="selectedPackage()!.package" [latestVersion]="selectedPackage()!.latestVersion" />
                            </p-tabpanel>
                        }
                    </p-tabpanels>
                </p-tabs>
            </div>
        }
    </div>
</div>

<p-dialog header="Clean Up Versions" [(visible)]="showCleanupDialog" [modal]="true" [style]="{ width: '450px' }">
    <div class="cleanup-form">
        <p>Delete versions uploaded before a date, debug builds, or everything but the newest versions — any one of these is enough. The latest version, versions running on a device and versions with a pending deployment are always kept.</p>
        <div class="field">
            <label for="cleanupBefore">Uploaded before</label>
            <p-datepicker inputId="cleanupBefore" [ngModel]="cleanupBefore()" (ngModelChange)="setCleanupBefore($event)" [showIcon]="true" appendTo="body" />
        </div>
        <div class="field cleanup-debug">
            <p-checkbox inputId="cleanupDebug" [binary]="true" [ngModel]="cleanupDebug()" (ngModelChange)="setCleanupDebug($event)" />
            <label for="cleanupDebug">Delete debug builds</label>
        </div>
        <div class="field">
            <label for="cleanupKeepNewest">Keep only the newest</label>
            <p-inputnumber inputId="cleanupKeepNewest" [ngModel]="cleanupKeepNewest()" (ngModelChange)="setCleanupKeepNewest($event)" [min]="1" [max]="10000" [showButtons]="true" suffix=" versions" placeholder="All versions" />
        </div>
        @if (canCleanUpVersions()) {
            @if (cleanupPreviewLoading()) {
                <p-message severity="secondary">Counting matching versions…</p-message>
            } @else if (cleanupPreviewError()) {
                <p-message severity="error">Could not count matching versions.</p-message>
            } @else if (cleanupPreview(); as preview) {
                <p-message [severity]="preview.matched ? 'warn' : 'info'">
                    {{ preview.matched ? preview.matched + ' version(s) (' + formatFileSize(preview.matchedBytes) + ') will be deleted.' : 'No versions can be deleted with these criteria.' }}
                </p-message>
                @if (preview.skippedInUse.length) {
                    <p-message severity="info" class="cleanup-kept">
                        {{ preview.skippedInUse.length }} matching version(s) will be kept because they are in use:
                        @for (skip of preview.skippedInUse.slice(0, 5); track skip.versionId) {
                            <span class="cleanup-kept-version">v{{ skip.assemblyVersion }}{{ skip.runningOnDevices ? ' (on ' + skip.runningOnDevices + ' device' + (skip.runningOnDevices === 1 ? '' : 's') + ')' : '' }}{{ skip.pendingDeployments ? ' (deploy pending)' : '' }}</span>
                        }
                        @if (preview.skippedInUse.length > 5) {
                            <span>and {{ preview.skippedInUse.length - 5 }} more</span>
                        }
                    </p-message>
                }
            }
        }
    </div>
    <ng-template #footer>
        <p-button label="Cancel" [text]="true" (onClick)="showCleanupDialog.set(false)" [disabled]="cleanupInProgress()" />
        <p-button label="Clean Up" icon="pi pi-trash" severity="danger" (onClick)="cleanUpVersions()" [disabled]="!canCleanUpVersions() || cleanupPreviewLoading() || !cleanupPreview()?.matched" [loading]="cleanupInProgress()" />
    </ng-template>
</p-dialog>

<!-- Upload dialog -->
<p-dialog header="Upload Package" [(visible)]="showUploadDialog" [modal]="true" [style]="{ width: '500px' }">
    <div class="upload-form">
        <div class="field">
            <label for="uploadNamespaceSelect">Target Tenant</label>
            <p-select id="uploadNamespaceSelect" [options]="uploadableNamespaces()" optionLabel="name" [ngModel]="uploadNamespace()" (ngModelChange)="uploadNamespace.set($event)" placeholder="Select tenant" [style]="{ width: '100%' }" [disabled]="uploading()"> </p-select>
        </div>

        <div class="field">
            <label>CPZ File</label>
            <div class="upload-dropzone"
                 [class.drag-over]="isDragOver()"
                 (dragover)="onDragOver($event)"
                 (dragleave)="onDragLeave($event)"
                 (drop)="onDrop($event)"
                 (click)="fileInput.click()">
                <i class="pi pi-cloud-upload upload-icon"></i>
                <div class="upload-text">
                    @if (uploadFile()) {
                        <span class="file-name">{{ uploadFile()!.name }}</span>
                        <span class="file-size">({{ formatFileSize(uploadFile()!.size) }})</span>
                    } @else {
                        <span>Drag and drop your <strong>.cpz</strong> file here, or <strong class="browse-link">browse</strong></span>
                    }
                </div>
                <input #fileInput type="file" accept=".cpz" style="display: none" (change)="onFileSelected($event)" [disabled]="uploading()" />
            </div>
        </div>

        <div class="field">
            <label>Release Notes (optional)</label>
            <textarea pInputTextarea rows="4" [(ngModel)]="uploadReleaseNotes" [disabled]="uploading()"></textarea>
        </div>
    </div>

    <ng-template #footer>
        <p-button label="Cancel" [text]="true" (onClick)="cancelUpload()" [disabled]="uploading()"></p-button>
        <p-button label="Upload" icon="pi pi-upload" (onClick)="uploadPackage()" [disabled]="!uploadFile() || uploading()" [loading]="uploading()"> </p-button>
    </ng-template>
</p-dialog>

<!-- Edit dialog -->
<p-dialog header="Edit Package" [(visible)]="showEditDialog" [modal]="true" [style]="{ width: '400px' }">
    <div class="edit-form">
        <div class="field">
            <label>Name</label>
            <input type="text" pInputText [(ngModel)]="editPackageName" [disabled]="savingEdit()" />
        </div>
        <div class="field">
            <label>Description</label>
            <textarea pInputTextarea rows="3" [(ngModel)]="editPackageDescription" [disabled]="savingEdit()"></textarea>
        </div>
        <div class="field">
            <label for="edit-package-repository">{{ t()('github.repository') }}</label>
            <input id="edit-package-repository" type="text" pInputText [(ngModel)]="editPackageRepository" [disabled]="savingEdit()" [placeholder]="t()('github.repositoryHint')" />
            <small>{{ t()('github.repositoryHint') }}</small>
        </div>
    </div>

    <ng-template #footer>
        <p-button label="Cancel" [text]="true" (onClick)="showEditDialog.set(false)" [disabled]="savingEdit()"></p-button>
        <p-button label="Save" icon="pi pi-check" (onClick)="saveEdit()" [loading]="savingEdit()"></p-button>
    </ng-template>
</p-dialog>

<!-- Deploy dialog -->
<p-dialog header="Deploy Package" [(visible)]="showDeployDialog" [modal]="true" [style]="{ width: '650px', maxWidth: '95vw' }" class="deploy-dialog" [appendTo]="'body'">
    @if (selectedVersion()) {
    <div class="deploy-form">
        <p class="deploy-info">Deploy <strong>{{ selectedPackage()?.package?.name }}</strong> v<strong>{{ selectedVersion()!.assemblyVersion }}</strong> to devices.</p>

        @if (loadingDevices()) {
        <div class="loading-devices">
            <p-progressspinner [style]="{ width: '30px', height: '30px' }"></p-progressspinner>
            <span>Loading compatible devices...</span>
        </div>
        } @else if (compatibleDevices().length === 0) {
        <div class="no-devices">
            <i class="pi pi-info-circle"></i>
            <p>No compatible devices found.</p>
            <small>Only devices with the same package namespace ({{ selectedPackage()?.package?.programNamespace || 'N/A' }}) are shown.</small>
        </div>
        } @else {
        <div class="device-filters">
            <input type="text" pInputText placeholder="Filter devices..." [ngModel]="deviceFilter()" (ngModelChange)="deviceFilter.set($event || '')" [disabled]="deploying()" />
        </div>
        @if (filteredCompatibleDevices().length === 0) {
        <div class="no-devices">
            <i class="pi pi-filter-slash"></i>
            <p>No devices match your filter.</p>
        </div>
        } @else {
        <div class="device-selection-header">
            <div class="select-all">
                <p-checkbox [binary]="true" [ngModel]="allDevicesSelected()" (ngModelChange)="toggleAllDevices()" [indeterminate]="someDevicesSelected()" inputId="selectAll" [disabled]="deploying()"> </p-checkbox>
                <label for="selectAll">Select All Visible ({{ filteredCompatibleDevices().length }} devices)</label>
            </div>
            @if (selectedDevicesCount() > 0) {
            <span class="selected-count">{{ selectedDevicesCount() }} selected</span>
            }
        </div>

        <div class="device-tree-list">
            @for (row of locationDeviceRows(); track row.id) {
            <div class="location-row" [style.paddingLeft.rem]="row.depth">
                <div class="location-header">
                    <p-checkbox
                        [binary]="true"
                        [ngModel]="isLocationFullySelected(row)"
                        (ngModelChange)="toggleLocationSelection(row)"
                        [indeterminate]="isLocationPartiallySelected(row)"
                        [inputId]="'location-' + row.id"
                        [disabled]="deploying()"
                    >
                    </p-checkbox>
                    <i class="pi pi-folder location-icon"></i>
                    <label [for]="'location-' + row.id">{{ row.name }}</label>
                    <span class="location-count">{{ row.devicesInSubtree.length }} device{{ row.devicesInSubtree.length !== 1 ? 's' : '' }}</span>
                </div>
                @if (row.devicesAtLocation.length > 0) {
                <div class="device-list">
                    @for (device of row.devicesAtLocation; track device.id) {
                    <div class="device-item" [class.selected]="device.selected" [class.ignored]="!deviceNeedsUpdate(device)">
                        <p-checkbox [binary]="true" [ngModel]="device.selected" (ngModelChange)="toggleDeviceSelection(device)" [inputId]="'device-' + device.id" [disabled]="deploying() || !deviceNeedsUpdate(device)"> </p-checkbox>
                        <div class="device-info">
                            <div class="device-name">
                                <span class="status-indicator-dot" [ngClass]="statusClass(device)" [pTooltip]="unifiedStatus(device)"></span>
                                <label [for]="'device-' + device.id">{{ displayName(device) }}</label>
                                @if (device.model) {
                                <span class="device-model">{{ device.model }}</span>
                                }
                            </div>
                            <div class="device-details">
                                <span class="version-info">
                                    @if (device.version) {
                                    <span class="current-version" [class.outdated]="deviceVersionStatus(device) === 'older'" [class.newer]="deviceVersionStatus(device) === 'newer'">
                                        v{{ device.version }}
                                        @if (deviceVersionStatus(device) === 'equal') {
                                        <i class="pi pi-check-circle up-to-date" pTooltip="Already on this version"></i>
                                        } @else if (deviceVersionStatus(device) === 'newer') {
                                        <i class="pi pi-info-circle newer-version" pTooltip="Newer version installed"></i>
                                        } @else {
                                        <i class="pi pi-arrow-right"></i> v{{ selectedVersion()!.assemblyVersion }}
                                        }
                                    </span>
                                    } @else {
                                    <span class="no-version">No version reported</span>
                                    }
                                </span>
                                <span class="last-seen" pTooltip="{{ formatDate(device.lastCheckInUtc) }}"> <i class="pi pi-clock"></i> {{ formatRelativeTime(device.lastCheckInUtc) }} </span>
                            </div>
                        </div>
                    </div>
                    }
                </div>
                }
            </div>
            }
        </div>
        }

        @if (duplicateProcessorWarning()) {
        <p-message severity="warn" class="mt-3 w-full">{{ duplicateProcessorWarning()! }}</p-message>
        } }
    </div>
    }

    <ng-template #footer>
        <p-button label="Cancel" [text]="true" (onClick)="showDeployDialog.set(false)" [disabled]="deploying()"></p-button>
        <p-button icon="pi pi-clock" [rounded]="true" [text]="true" (onClick)="showScheduleDialog.set(true)" [disabled]="selectedDevicesCount() === 0 || deploying()" pTooltip="Schedule deployment" tooltipPosition="top"> </p-button>
        <p-button
            [label]="'Deploy to ' + selectedDevicesCount() + ' Device' + (selectedDevicesCount() !== 1 ? 's' : '')"
            icon="pi pi-cloud-upload"
            (onClick)="deployToDevices()"
            [disabled]="selectedDevicesCount() === 0 || deploying()"
            [loading]="deploying()"
        >
        </p-button>
    </ng-template>
</p-dialog>

<!-- Schedule deployment dialog -->
<p-dialog header="Schedule Deployment" [(visible)]="showScheduleDialog" [modal]="true" [style]="{ width: '400px' }" [appendTo]="'body'">
    <div class="schedule-form">
        <p class="schedule-info">Schedule deployment of <strong>{{ selectedPackage()?.package?.name }}</strong> v<strong>{{ selectedVersion()?.assemblyVersion }}</strong> to {{ selectedDevicesCount() }} device(s).</p>

        <div class="field">
            <label for="scheduledDate">Deployment Date & Time</label>
            <p-datepicker inputId="scheduledDate" [(ngModel)]="scheduledDateTime" [showTime]="true" [showIcon]="true" [minDate]="minScheduleDate" dateFormat="yy-mm-dd" [appendTo]="'body'" class="w-full"> </p-datepicker>
            <small class="hint">All times are in your local timezone</small>
        </div>
    </div>

    <ng-template #footer>
        <p-button label="Cancel" [text]="true" (onClick)="showScheduleDialog.set(false)" [disabled]="deploying()"></p-button>
        <p-button label="Schedule Deployment" icon="pi pi-clock" (onClick)="deployToDevicesScheduled()" [disabled]="!scheduledDateTime || deploying()" [loading]="deploying()"> </p-button>
    </ng-template>
</p-dialog>

<!-- Version release notes dialog -->
<p-dialog header="Release Notes - v{{ versionReleaseNotes()?.version }}" [(visible)]="showVersionReleaseNotesDialog" [modal]="true" [style]="{ width: '600px', maxWidth: '95vw' }" class="release-notes-dialog" [closable]="true">
    @if (versionReleaseNotes()) {
    <div class="release-notes-content" [innerHTML]="versionReleaseNotes()!.notes | markdown"></div>
    }
</p-dialog>

<!-- Console command dialog -->
<p-dialog
    [header]="t()('console.title') + ' - v' + consoleCommandVersion()?.assemblyVersion"
    [visible]="showConsoleCommandDialog()"
    (visibleChange)="!$event && closeConsoleCommandDialog()"
    [modal]="true"
    [style]="{ width: '650px', maxWidth: '95vw' }"
    class="console-command-dialog"
    [closable]="true">
    <p class="picker-intro">{{ t()('console.intro') }}</p>
    @if (consoleCommandModes().length > 1) {
        <div class="field">
            <p-selectbutton [options]="consoleCommandModes()" optionLabel="label" optionValue="value" [ngModel]="consoleCommandMode()" (ngModelChange)="consoleCommandMode.set($event); refreshConsoleCommand()" [allowEmpty]="false" [disabled]="consoleCommandLoading()" />
        </div>
    }
    @if (consoleCommandMode() === 'link') {
        <p class="text-color-secondary">{{ t()('console.linkHint') }}</p>
        <p-button [label]="t()('console.createLink')" icon="pi pi-link" (onClick)="createShareableLink()" />
    } @else {
        <p class="text-color-secondary">{{ t()('console.quickHint') }}</p>
        <div class="field">
            <label for="consoleExpiry">{{ t()('console.expiry') }}</label>
            <p-select inputId="consoleExpiry" [options]="consoleCommandExpiryOptions" optionLabel="label" optionValue="value" [ngModel]="consoleCommandExpiry()"
                (ngModelChange)="consoleCommandExpiry.set($event); refreshConsoleCommand()" [disabled]="consoleCommandLoading()" appendTo="body" class="w-full" />
            <small class="hint text-color-secondary">{{ t()('console.expiringHint') }}</small>
        </div>
        @if (consoleCommandLoading()) {
        <div class="loading-state flex justify-content-center p-4">
            <p-progressspinner [style]="{ width: '2rem', height: '2rem' }"></p-progressspinner>
        </div>
        } @else if (consoleCommandError()) {
            <app-empty-state tone="error" [title]="t()('console.error')" [actionLabel]="t()('management.refresh')" (action)="refreshConsoleCommand()" />
        } @else if (consoleCommandDownloadUrl()) {
        <p-message severity="info" icon="pi pi-clock">{{ consoleCommandValidUntil() }}</p-message>
        <p class="text-color-secondary">{{ t()('console.hostHint') }}</p>

        <div class="field">
            <label for="consoleCommandSlot">{{ t()('console.slot') }}</label>
            <input
                id="consoleCommandSlot"
                type="number"
                pInputText
                min="1"
                max="99"
                [ngModel]="consoleCommandProgramSlot()"
                (ngModelChange)="setConsoleCommandProgramSlot($event)"
                class="w-full" />
        </div>

        <div class="field">
            <label>{{ t()('console.step1') }}</label>
            <div class="console-command-block">
                <pre><code>{{ consoleCommandFgetfileCommand() }}</code></pre>
                <p-button icon="pi pi-copy" [text]="true" [rounded]="true" size="small" class="console-command-copy" (onClick)="copyToClipboard(consoleCommandFgetfileCommand())" [pTooltip]="t()('console.copy')" [ariaLabel]="t()('console.copy')"></p-button>
            </div>
        </div>

        <div class="field">
            <label>{{ t()('console.step2') }}</label>
            <div class="console-command-block">
                <pre><code>{{ consoleCommandProgloadCommand() }}</code></pre>
                <p-button icon="pi pi-copy" [text]="true" [rounded]="true" size="small" class="console-command-copy" (onClick)="copyToClipboard(consoleCommandProgloadCommand())" [pTooltip]="t()('console.copy')" [ariaLabel]="t()('console.copy')"></p-button>
            </div>
        </div>
        }
    }

    <ng-template #footer>
        <p-button label="Close" [text]="true" (onClick)="closeConsoleCommandDialog()"></p-button>
    </ng-template>
</p-dialog>

<!-- Location package picker dialog -->
<p-dialog
    [header]="'Deploy to ' + (preSelectLocationName() || 'Location')"
    [(visible)]="showLocationPackagePickerDialog"
    [modal]="true"
    [style]="{ width: '480px', maxWidth: '95vw' }"
    [appendTo]="'body'">
    <p class="picker-intro">Multiple packages have devices at this location. Select which to update:</p>
    <div class="location-packages-list">
        @for (opt of locationPackages(); track opt.package.id) {
        <div class="location-package-option" (click)="selectLocationPackage(opt.package)">
            <div class="lpo-info">
                <div class="lpo-name">{{ opt.package.name }}</div>
                <code class="lpo-ns">{{ opt.package.programNamespace }}</code>
            </div>
            <p-tag [value]="opt.deviceCount + ' device' + (opt.deviceCount !== 1 ? 's' : '')" severity="info"></p-tag>
        </div>
        }
    </div>
    <ng-template #footer>
        <p-button label="Cancel" [text]="true" (onClick)="showLocationPackagePickerDialog.set(false)"></p-button>
    </ng-template>
</p-dialog>

<!-- Confirmation dialog -->
<p-confirmdialog></p-confirmdialog>
